import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { DESTINATION_ORDERED, IMAGES } from "../lib/images";
import { DESTINATIONS } from "../lib/destinations";

export const Destinations = () => {
  const { t } = useI18n();
  const list = t("destinations.list") || [];
  const pillars = `${t("aviation.label")} · ${t("yachts.label")} · ${t("villas.label")} · ${t("concierge.label")}`;

  return (
    <section id="destinations" className="py-28 md:py-40 border-b border-vm-border" data-testid="destinations-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="vm-label mb-5">{t("destinations.label")}</p>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
            <h2 className="font-serif font-light leading-[1] text-4xl md:text-6xl max-w-2xl">{t("destinations.title")}</h2>
            <p className="text-vm-text2 font-light max-w-sm text-sm leading-relaxed">{t("destinations.body")}</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-vm-border">
          {list.map((d, i) => (
            <Reveal key={d + i} delay={(i % 4) * 0.06}>
              <Link
                to={`/destinations/${DESTINATIONS[i]?.slug || ""}`}
                className="group relative w-full aspect-[4/5] overflow-hidden bg-vm-bg block text-left"
                data-testid={`destination-${i}`}
                aria-label={d}
              >
                <img
                  src={DESTINATION_ORDERED[i] || IMAGES.coastline}
                  alt={`VELMONTÉ private office — ${d}`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-90 group-hover:scale-105 transition-all duration-[1000ms]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <span className="font-serif text-2xl md:text-3xl font-light block">{d}</span>
                  <span className="block mt-2 text-[0.6rem] tracking-[0.18em] uppercase text-vm-accent opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                    {pillars}
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
